export default "__VITE_ASSET__6271c27c__"